import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeparationRoutingModule } from './separation-routing.module';
import { SeparationListComponent } from './separation-list/separation-list.component';
import { SeparationComponent } from './separation-wizard/separation/separation.component';
import { LoneStatusComponent } from './separation-wizard/lone-status/lone-status.component';
import { ExitInterviewComponent } from './separation-wizard/exit-interview/exit-interview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SeparationWizardComponent } from './separation-wizard/separation-wizard.component';
import { AccessRevocationComponent } from './separation-wizard/access-revocation/access-revocation.component';
import { ExitClearanceComponent } from './separation-wizard/exit-clearance/exit-clearance.component';
import { FinalSettlementComponent } from './separation-wizard/final-settlement/final-settlement.component';
import { DocumentDownloadComponent } from './separation-wizard/doucment-download/document-download.component';
import { TerminationListComponent } from './termination-list/termination-list.component';
import { StatusTrackingComponent } from './separation-wizard/status-tracking/status-tracking.component';
import { SeparationApprovalListComponent } from './separation-approval-list/separation-approval-list.component';
import { LOneApprovalListComponent } from './l-one-approval/l-one-approval-list/l-one-approval-list.component';
import { LOneApprovalComponent } from './l-one-approval/l-one-approval/l-one-approval.component';
import { TerminationAppealComponent } from './separation-wizard/termination-appeal/termination-appeal.component';
import { TerminationWizardComponent } from './termination-wizard/termination-wizard.component';
import { TerminantionEmpAppealComponent } from './terminantion-emp-appeal/terminantion-emp-appeal.component';

@NgModule({
  declarations: [
    SeparationListComponent,
    SeparationComponent,
    LoneStatusComponent,
    ExitInterviewComponent,
    SeparationWizardComponent,
    AccessRevocationComponent,
    ExitClearanceComponent,
    FinalSettlementComponent,
    DocumentDownloadComponent,
    TerminationListComponent,
    StatusTrackingComponent,
    SeparationApprovalListComponent,
    LOneApprovalListComponent,
    LOneApprovalComponent,
    TerminationAppealComponent,
    TerminationWizardComponent,
    TerminantionEmpAppealComponent,
  ],
  imports: [
    CommonModule,
    SeparationRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PerfectScrollbarModule,
  ]
})
export class SeparationModule { }
